module.exports = __webpack_public_path__ + "static/media/spicycrabmeat.e95a7e3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/protein/spicycrabmeat.jpg
// module id = 109
// module chunks = 0